import { FC, useCallback, useContext } from 'react'

import MatterDropdown from '../../../common/MatterDropdown'
import { FundRequestsContext } from '../../../../context/FundRequestsContext'
import { QUERY_PARAMS } from '../../../../constants'

const MatterFilter: FC = () => {
  const { filters, setFilters } = useContext(FundRequestsContext)

  const getFilterValues = useCallback(
    (key: QUERY_PARAMS) => (key === QUERY_PARAMS.MATTER ? (filters.matter?.id ?? QUERY_PARAMS.ALL) : ''),
    [filters.matter?.id]
  )

  const setParams = useCallback(
    (key: QUERY_PARAMS, value: string) => {
      if (key === QUERY_PARAMS.MATTER) {
        setFilters({
          matter: value === QUERY_PARAMS.ALL ? undefined : { id: value, title: undefined }
        })
      }
    },
    [setFilters]
  )

  const customOnChange = useCallback(
    (option: { id: string; title?: string | null } | null) => {
      setFilters({
        matter: option ? { id: option.id, title: option.title ?? undefined } : undefined
      })
    },
    [setFilters]
  )

  return (
    <MatterDropdown
      label="Matter"
      sx={{ minWidth: 320 }}
      setParams={setParams}
      getFilterValues={getFilterValues}
      customOnChange={customOnChange}
    />
  )
}

export default MatterFilter
